import { createContext, useContext, type ReactNode, type RefObject } from 'react'

/**
 * Sticky buy-CTA chrome for sell landings (Elite Plans + Elite Prime).
 *
 * Belongs here: refs + visibility for the inline CTA and floating bar.
 * Does not belong here: FAB layout, CTA payload, or consent.
 */
export type ElitePlansFloatingCtaContextValue = {
  enableFloatingCta: boolean
  /** True when the floating bar should show (inline CTA not sufficiently intersecting). */
  isFloatingCtaVisible: boolean
  floatingCtaRef: RefObject<HTMLDivElement | null>
  inlineCtaRef: RefObject<HTMLDivElement | null>
}

const ElitePlansFloatingCtaContext = createContext<ElitePlansFloatingCtaContextValue | null>(null)

export function ElitePlansFloatingCtaProvider({
  value,
  children
}: {
  value: ElitePlansFloatingCtaContextValue
  children: ReactNode
}) {
  return (
    <ElitePlansFloatingCtaContext.Provider value={value}>{children}</ElitePlansFloatingCtaContext.Provider>
  )
}

/** Returns null when outside a sell landing (e.g. member dashboard). */
export function useElitePlansFloatingCta(): ElitePlansFloatingCtaContextValue | null {
  return useContext(ElitePlansFloatingCtaContext)
}
